import { FC, ReactNode } from 'react';
import { Box, Chip } from '@mui/material';
import { STATUS_COLOR, STATUS_LABEL } from './platformApi';

interface IPlatformCardProps {
  title: string;
  action?: ReactNode;
  // buttons in a row along the bottom of the card
  footer?: ReactNode;
  // stretch to the row height so side-by-side cards line up
  fill?: boolean;
}

// Card with the grey title strip used across the app
export const PlatformCard: FC<IPlatformCardProps> = ({ title, action, footer, fill, children }) => (
  <Box sx={{ bgcolor: '#fff', border: '1px solid #dcdcdc', borderRadius: '8px', ...(fill ? { height: '100%', display: 'flex', flexDirection: 'column' } : {}) }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1, px: '15px', py: 0.75, minHeight: 38, bgcolor: '#e9ecf1', borderBottom: '1px solid #dcdcdc', borderRadius: '8px 8px 0 0' }}>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, margin: 0, whiteSpace: 'nowrap' }}>{title}</h5>
      {action}
    </Box>
    {/* wide tables scroll inside the card, not the page */}
    <Box sx={{ p: '12px 15px', overflowX: 'auto', flexGrow: 1 }}>{children}</Box>
    {footer && (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: 1, px: '15px', py: 1, borderTop: '1px solid #e9ecf1', bgcolor: '#fafafb', borderRadius: '0 0 8px 8px' }}>
        {footer}
      </Box>
    )}
  </Box>
);

export const Field: FC<{ title: string }> = ({ title, children }) => (
  <div>
    <h5 style={{ fontWeight: 'normal', color: '#6b7280', fontSize: 13, margin: 0 }}>{title}</h5>
    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, margin: '2px 0 3px' }}>{children}</h5>
  </div>
);

export const StatusChip: FC<{ status?: string | null }> = ({ status }) =>
  status ? <Chip size='small' variant='outlined' color={STATUS_COLOR[status] || 'default'} label={STATUS_LABEL[status] || status} /> : <span>-</span>;
